import { ChevronLeftRounded, ChevronRightRounded, Height } from '@mui/icons-material';
import { Chip, Divider, Grid, IconButton, Stack, Typography,Box, Tooltip, Skeleton } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import useDevice from '../../hooks/useDevice';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CategoryArrow from '../../components/carousel/CategoryArrow';
import { useRouter } from 'next/router';
import { useCategoriesAll } from '../../hooks/useCategoriesAll';
import EkhoolImage from '../../components/ekhoolImage/ekhoolImage';


const CustomCategoryListing1 = ({ item, ...props }) => {
    
    const  DataCategory =[

        {
            "id": "30",
            "ct_name": "Category 1",
            "ct_status": "1",
            "ct_parent_id": "0",
            "ct_slug": "master",
            "ct_route_id": "179",
            "ct_deleted": "0",
            "ct_account_id": "237",
            "action_id": "1",
            "action_by": "1",
            "created_date": "2022-12-15 10:37:05",
            "updated_date": "2016-01-01 00:00:00",
            "order_id": "0",
            "ct_tag": "MR",
            "ct_image":"https://ditrpindia.com/images/defaultcourse.jpg",
            "ct_description" : "Hover over this to Look after the remaining Text , Lorem ipsum lorem ipsum dolerum lorem lorem , Lorem ipsum lorem ipsum dolerum lorem lorem"
        },
        {
            "id": "32",
            "ct_name": "Category 2",
            "ct_status": "1",
            "ct_parent_id": "0",
            "ct_slug": "site-test",
            "ct_route_id": "197",
            "ct_deleted": "0",
            "ct_account_id": "237",
            "action_id": "1",
            "action_by": "1",
            "created_date": "2023-01-24 19:09:35",
            "updated_date": "2016-01-01 00:00:00",
            "order_id": "0",
            "ct_tag": "MR",
            // "ct_image":"https://ditrpindia.com/images/defaultcourse.jpg",
            "ct_description" : "Hover over this to Look after the remaining Text , Lorem ipsum lorem ipsum dolerum lorem lorem , Lorem ipsum lorem ipsum dolerum lorem lorem"

        },
        {
            "id": "33",
            "ct_name": "Category 3",
            "ct_status": "1",
            "ct_parent_id": "0",
            "ct_slug": "site-build-test",
            "ct_route_id": "198",
            "ct_deleted": "0",
            "ct_account_id": "237",
            "action_id": "1",
            "action_by": "1",
            "created_date": "2023-01-25 15:15:41",
            "updated_date": "2016-01-01 00:00:00",
            "order_id": "0",
            "ct_tag": "Diseasess",
            "ct_image":"https://ditrpindia.com/images/defaultcourse.jpg",
            "ct_description" : "Hover over this to Look after the remaining Text , Lorem ipsum lorem ipsum dolerum lorem lorem , Lorem ipsum lorem ipsum dolerum lorem lorem"


        },
        {
            "id": "34",
            "ct_name": "Category 4",
            "ct_status": "1",
            "ct_parent_id": "0",
            "ct_slug": "ok-bro",
            "ct_route_id": "199",
            "ct_deleted": "0",
            "ct_account_id": "237",
            "action_id": "1",
            "action_by": "1",
            "created_date": "2023-01-25 15:16:42",
            "updated_date": "2016-01-01 00:00:00",
            "order_id": "0",
            "ct_tag": "Diseasess",
            "ct_image":"https://img-b.udemycdn.com/notices/web_carousel_slide/image/e6cc1a30-2dec-4dc5-b0f2-c5b656909d5b.jpg",
            "ct_description" : "Hover over this to Look after the remaining Text , Lorem ipsum lorem ipsum dolerum lorem lorem , Lorem ipsum lorem ipsum dolerum lorem lorem"

        },
        
    ] 
    const theme = useTheme();
    const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMdScreen = useMediaQuery(theme.breakpoints.down('md'));
    const { reducer } = useSelector((state) => state);
    const [loading, setLoading] = useState(true);
    const { headers, pageJson ,isSiteBuilder } = reducer || {};
    
    const [allCategories, setAllCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [imageUrl, setImageUrl] = useState("");




    const getCategoryData = async () => {
        const result = await useCategoriesAll()
        setImageUrl(result.cat_image_path);
        setAllCategories(result.categories)
        if(result?.length > 0)
        {
            setSelectedCategory(result[0])
        }
        setLoading(false)
    }

    useEffect(() => {
        if(isSiteBuilder)
            {
                setAllCategories(DataCategory);
            }
    }, []);




    useEffect(() => {
        if(!isSiteBuilder)
    {
        getCategoryData()
    }
    }, []);


    const scrollRef = useRef(null);
    const scrollRef1 = useRef(null);
    const programCardScroll = (scrollOffset) => {
        return scrollRef ? (scrollRef.current.scrollLeft += scrollOffset) : null;
    };
    const programCardScroll1 = (scrollOffset) => {
        if (scrollRef1) {
          const scrollNode = scrollRef1.current;
          const currentScrollLeft = scrollNode.scrollLeft;
          const newScrollLeft = currentScrollLeft + scrollOffset;
          scrollNode.scrollTo({
            left: newScrollLeft,
            behavior: 'smooth'
          });
        }
      };
    const { isMobile, isTablet } = useDevice();
    const [isHovered, setIsHovered] = useState(null);
    const { push } = useRouter()


    return (
        <Stack>

          {(isSmScreen ? allCategories.length > 1 : allCategories.length > 4 || isSiteBuilder) && ( 
            <Box
                sx={{
                    display: isSmScreen ? "" : "flex",
                    marginTop: '20px',
                    justifyContent: 'flex-end',
                    position: 'relative', // Make sure the container is positioned
                    zIndex: 10,           // Ensure the arrows are on top
                }}
            >
                <CategoryArrow
                    customIcon={'ic:round-keyboard-arrow-right'}
                    onNext={() => { programCardScroll1(500) }}
                    onPrevious={() => { programCardScroll1(-500) }}
                    isSiteBuilder={isSiteBuilder}
                    scrollContainerRef={scrollRef1}
                    previousText={
                        <span
                            data-key="prevText"
                            contentEditable ={isSiteBuilder}
                        >
                            {item?.props?.prevText ?? 'Less'}
                        </span>
                    }
                    nextText={
                        
                        <span
                            data-key="nextText"
                            contentEditable = {isSiteBuilder}
                        >
                            {item?.props?.nextText ?? 'More'}
                        </span>
                    }
                    sx={{
                        '& .arrow': { width: 28, height: 28, p: 0, zIndex: 10 }, // High z-index for arrows
                    }}
                />
            </Box>
        
        ) }
            <Stack direction={'row'} gap={4} sx={{ height:'320px',overflowX: 'auto' , paddingTop:isSmScreen ? "10px" : "" }} divider={<Divider orientation='vertical' flexItem  />}  ref={scrollRef1}>
                {(loading && !isSiteBuilder) && (
                    <Stack direction="row" gap={4}>
                        {[1, 2, 3, 4,5].map((i) => (
                            <Box
                                key={i}
                                sx={{
                                    minWidth: isMobile ? "366px" : "330px",
                                    maxWidth: isMobile ? "366px" : "330px",
                                    height: "290px",
                                }}
                            >
                                <Skeleton   variant="rectangular"  sx={{ width: "100%",height: "200px"}}/>
                                <Skeleton variant="text"  height={35}width="80%"/>

                            </Box>
                        ))}
                    </Stack>
                )}


                {
                    allCategories?.map((item, index) => {
                        // console.log(allCategories,'allCategories')
                        const isSelected = item?.id == selectedCategory?.id
                        return (
                            <>
                                <Box 
                                key={item.id}
                                style={{
                                    minWidth: isMobile ?  '366px' : '330px',
                                    maxWidth: isMobile ?  '366px' : '330px',

                                    height:'290px',
                                    // padding:'4px',
                                    marginTop:'4px',
                                    position:'relative',
                                    cursor: "pointer",
                                    
                                    borderTopLeftRadius: '20px',
                                    borderTopRightRadius: '20px'
                                }}
                                sx={{ boxShadow:  isHovered === item.id ?    `3px 5px 4px 2px ${theme?.palette?.primary?.lighter}` : 5,transition: 'box-shadow 0.8s ease', }}
                                onMouseEnter={() => setIsHovered(item.id)}
                                onMouseLeave={() => setIsHovered(null)}
                                onClick={() => {
                                   !isSiteBuilder && push(`/category/${item.ct_slug}`);

                                }}
                                >
                                    <Stack sx={{width:'100%',height:'200px',display:'flex',justifyContent:'center',alignItems:'center',borderTopLeftRadius: '20px',borderTopRightRadius: '20px'}} >
                                     
                                        <EkhoolImage 
                                                style={{ width: '100%', height: '100%', borderTopLeftRadius: '18px', borderTopRightRadius: '19px',borderBottom: "4px solid " }} 
                                                src={item.ct_image =="default" ?   'https://playatcreation.com/images/default-course-thumbnail.png'   : imageUrl+item.ct_image } 
                                                objectFit="cover" 
                                            />
                                            
                                    </Stack>
                                    <h3 style={{overflow:'hidden',marginLeft:'10px',textOverflow:'ellipsis',fontWeight:'800',display: 'inline-block',maxWidth: '100%', WebkitLineClamp: 1,whiteSpace: 'nowrap',  WebkitBoxOrient: 'vertical',borderBottom:`4px solid ${theme?.palette?.primary?.light}`  }}  > {item?.ct_name} </h3>
                                    
                                    {(item.ct_description && isHovered == item.id) && (
                                        // <>
                                                <Stack
                                                    style={{
                                                        backgroundColor: 'black',
                                                        position: 'absolute',
                                                        height: '140px',
                                                        bottom: 0,
                                                        borderTopLeftRadius: '18px',
                                                        borderTopRightRadius: '19px',
                                                        padding: '12px',
                                                        transform: isHovered == item.id ? 'translateX(0)' : 'translateX(-100%)',
                                                        transition: 'transform 5.5s ease, opacity 5.5s ease', 
                                                        opacity: isHovered == item.id ? 1 : 0, 
                                                        pointerEvents: isHovered === item.id ? 'auto' : 'none', 
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            fontWeight: 600,
                                                            color: 'white',
                                                            paddingLeft: '8px',
                                                            borderColor: isHovered === item.id ? `${theme?.palette?.primary?.lighter}` : '',
                                                            overflowWrap: 'anywhere',
                                                        }}
                                                        className=''
                                                    >
                                                        {item.ct_description}
                                                    </p>
                                                </Stack>

                                    )}
                                    {item.ct_description &&
                                    <p
                                    style={{ paddingLeft:'10px',fontSize:'14px',fontWeight:300,display: '-webkit-box', WebkitLineClamp: 2,  WebkitBoxOrient: 'vertical',  overflow:'hidden',textOverflow:'ellipsis',paddingRight:'10px',fontStyle:"italic" }} className=''>{item.ct_description}</p>
                                     }
                                </Box>
                       
                            </>
                        )
                    })
                }
            </Stack> 
        </Stack>
    )
};

export default CustomCategoryListing1;